import MessageCenter from "cd-eft/components/common/MessageCenter/MessageCenterVM";

const AllowedDEMFormat = [
    'image/tiff'
]

/**
 * Additional validation for DEM file uploads. Checks MIME type and file size.
 * MIME type should be image/tiff and size < 500 MB (500 * 10^6 Bytes).
 * Additional, potentially more accurate validation could be done by checking the first bytes of the file data for the
 * sequences [49 49 2A 00] or [4D 4D 00 2A] (if Big Endian).
 * @param file DEM file from input files array.
 * @returns true if valid, false if invalid.
 */
export function validateDemFile(file: File): boolean {
    // DEM_20, Hydro_20
    // DEM_02 for size upload
    // DEM_04 for DEM validation
    // Hydro_24 has error in file selection?
    const { type, size } = file;
    // 500e6 should be 500,000,000 Bytes or 500 MB
    if (size > 500e6) {
        MessageCenter.addNotificationFromCode_object({
            code: "DEM_02"
        })
        return false;
    }
    else if (!AllowedDEMFormat.find((demType) => type === demType)) {
        MessageCenter.addNotificationFromCode_object({
            code: "Hydro_24"
        })
        return false;
    }
    else {
        return true;
    }
}

